import React from "react";

import { FormProvider, UseFormReturn } from "react-hook-form";

import Typography from "@mui/material/Typography";

import StyledFormInput from "components/FormInput/FormInput";
import StyledFormCheckbox from "components/FormInput/FormCheckbox";

import { DeleteReason, FormValues } from "./validation";

interface Step2Props {
  methods: UseFormReturn<FormValues>;
}

const options = [
  DeleteReason.MissingFunctionality,
  DeleteReason.InconvenientInterface,
  DeleteReason.NotNeededCurrently,
  DeleteReason.InsufficientSupport,
  DeleteReason.Other,
];

const Step2: React.FC<Step2Props> = ({ methods }) => {
  const reason = methods.watch("reason");

  return (
    <>
      <Typography variant="body1" color="grey800" sx={{ mb: 2 }}>
        Ваша думка важлива для нас. Поділіться, будь ласка, причиною — ми прагнемо вдосконалюватися.
      </Typography>
      <FormProvider {...methods}>
        <StyledFormCheckbox options={options} name="reason" />
        {reason.includes(DeleteReason.Other) && (
          <StyledFormInput name="notes" multiline rows={4} fullWidth />
        )}
      </FormProvider>
    </>
  );
};

export default Step2;
